<template>
	<div class="top">
		<div class="swiper mySwiper">
			<div class="swiper-wrapper">
				<div class="swiper-slide"><img src="~@/assets/images/banner1.jpg" alt=""></div>
				<div class="swiper-slide"><img src="~@/assets/images/banner2.jpg" alt=""></div>
				<div class="swiper-slide"><img src="~@/assets/images/banner3.jpg" alt=""></div>
				<div class="swiper-slide"><img src="~@/assets/images/banner4.jpg" alt=""></div>
				<div class="swiper-slide"><img src="~@/assets/images/banner5.jpg" alt=""></div>
			</div>
			<div class="swiper-pagination"></div>
		</div>
		<div class="top-list2">
			<div class="title">{{resDatas.title}}</div>
			<div class="product-main">
				<ul>
					<li v-for="(item,index) in resDatas.gamelist" @click="toProduct()">
						<div class="list-item">
							<div class="list-banner">
								<img :src="require('../assets/images/list-img'+index+'.jpg')" alt="">
								<div class="banner-title">
									<a>{{item.bannerTitle}}</a>
								</div>
							</div>
							<img class="game-icon" :src="require('../assets/images/icon'+index+'.png')" alt="">
							<div class="text-box">
								<h3>{{item.gameName}}</h3>
							</div>

							<div class="text-box">
								<p>{{item.gameIntro}}</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import 'swiper/dist/css/swiper.min.css';
	import Swiper from 'swiper';
	export default {
		data() {
			return {
				resDatas: ''
			}
		},
		props: {
			resData: {}
		},
		watch: {
			resData(newData) {
				this.resDatas = newData;
			}
		},
		methods: {
			toProduct() {
				this.$store.state.highlight = "product";
				this.$router.push('/product');
			}
		},
		mounted() {
			let swiper1 = new Swiper('.mySwiper', {
				slidesPerView: "auto",
				spaceBetween: 0,
				loop: true,
				centeredSlides: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
			});
			this.$parent.getlan();
		}
	}
</script>

<style scoped>
	.top {
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	.swiper {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.swiper-slide {
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
	}

	.swiper-slide {
		width: 1042px;
		height: 574px;
		opacity: 0.5;
	}

	.swiper-slide img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.swiper-slide-active {
		opacity: 1;
	}

	.top-list2 {
		max-width: 1000px;
		margin: auto;
		padding-top: 3%;
	}

	.top-list2 .title {
		font-size: 20px;
		font-weight: 700;
		text-align: center;
	}

	.product-main {
		padding-top: 3%;
	}

	.product-main ul {}

	.product-main ul::after {
		content: '';
		clear: both;
		display: block;
	}

	.product-main li {
		width: 48%;
		margin-bottom: 3%;
	}

	.product-main li:nth-of-type(2n+1) {
		float: left;
	}

	.product-main li:nth-of-type(2n+2) {
		float: right;
	}

	.list-item {
		position: relative;
		background-color: white;
		overflow: hidden;
		border-radius: 5px;
	}

	.list-banner {
		position: relative;
		overflow: hidden;
		height: 270px;
	}

	.list-banner img {
		width: 100%;
		height: 100%;
		transition: all .3s;
	}

	.banner-title {
		position: absolute;
		height: 0;
		width: 100%;
		bottom: 0;
		background-color: rgba(0, 0, 0, .9);
		transition: all .3s;
		cursor: pointer;
	}

	.banner-title a {
		display: block;
		color: white;
		line-height: 50px;
		text-align: center;
		font-size: 16px;
	}

	.game-icon {
		display: inline-block;
		width: 80px;
		position: relative;
		left: 50%;
		margin: auto;
		transform: translate(-50%, -50%);
		transition: all .3s;
		border-radius: 8px;
	}

	.text-box {
		transform: translateY(-100%);
	}

	.text-box h3 {
		font-size: 18px;
		position: relative;
		left: 50%;
		transform: translateX(-50%);
		display: inline-block;
		transition: all .3s;
	}

	.text-box p {
		font-size: 14px;
		position: relative;
		display: inline-block;
		transition: all .3s;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;
		padding: 0 5%;
		box-sizing: border-box;
		text-align: center;
	}

	.list-item:hover .game-icon {
		left: 5%;
		transform: translate(0%, -50%);
	}

	.list-item:hover h3,
	.list-item:hover p {
		left: 5%;
		transform: translateX(0);
		padding: 0;
		padding-right: 10%;
		text-align: left;
	}

	.list-item:hover .banner-title {
		height: 50px;
	}

	.list-item:hover .list-banner img {
		transform: scale(1.1);
	}

	@media screen and (max-width: 1000px) {
		.swiper-slide {
			width: 100%;
			height: auto;
		}

		.product-main li {
			width: 100%;
			padding: 0 3%;
			box-sizing: border-box;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/top.vue